import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonService {

  public logged_in_user_details = new BehaviorSubject({});
  public logged_in_user_image: any;

  public profile: any;

  search_term = '';
  video_data: any;


  // is_search_clicked: boolean = false
  // all_search_terms:any;
  // show_filter_button=false;
  // dropdowns: any;

  constructor(public apiCallService: ApiService, private domSanitizer: DomSanitizer) {
    let api_url = environment.backendConfig.url;
    this.apiCallService.Celery = api_url + '/celery';
    this.apiCallService.DB_Service = api_url + '/db';
    this.apiCallService.File_Service = api_url + '/file';
    this.apiCallService.Vision_Warehouse = api_url + '/vision-warehouse';
    this.apiCallService.Storage_CDN = environment.backendConfig.storage_cdn;
  }

  getUserDetails() {

    this.apiCallService.getProfile().subscribe(profile => {
      this.logged_in_user_details.next(profile);
    });

    this.logged_in_user_details.subscribe((profile: any) => {
      this.profile = profile;
    })
  }

  async getUser_image() {
    let response = await this.apiCallService.get_user_image().subscribe({
      next: (blob: any) => {
        var urlCreator = window.URL || window.webkitURL;
        this.logged_in_user_image = this.domSanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(blob)
        )
      },
      error: (err: any) => {
        let element = document.createElement('span');
        element.classList.add('avatar_initials');
        element.style.setProperty('font-weight', '600')
        element.innerHTML = this.get_initials(this.profile.displayName)
        document.getElementById('avatar')?.appendChild(element);
        this.logged_in_user_image = false;
      }
    })
  }

  get_initials(name: any) {
    if (name) {
      let output = '';
      let name_array = name.replaceAll(' ', '').split(',');
      name_array?.forEach((name: string) => {
        output = output + name.charAt(0)
      })
      return output.toUpperCase();
    }
    return "";
  }

  get_duration(time_seconds: any) {
    var h = Math.floor(time_seconds / 3600).toString().padStart(2, "0");
    var m = Math.floor(time_seconds % 3600 / 60).toString().padStart(2, "0");
    var s = Math.floor(time_seconds % 3600 % 60).toString().padStart(2, "0");
    if (h === '00') {
      return m + ":" + s;
    }
    return h + ":" + m + ":" + s;
  }


  get_length(item: any) {
    return item.length;
    // let length = 0;
    // if (item) {
    //   let keys = Object.keys(item);
    //   if (keys) [
    //     keys.forEach((key: string) => {
    //       length = length + item[key].length
    //     })
    //   ]
    // }

    // return length;
  }

  downloading: any = [];
  message_broker:any = new BehaviorSubject<any>({});

  async download_trimmed_video(file_name: string, body: any, id:any): Promise<any> {
    const res_blob = await this.apiCallService.get_trimmed_video(body);
    let file_to_download = res_blob;
    file_to_download.subscribe({
      next: (res: any) => {
        if (res == null) return null
        let url = window.URL.createObjectURL(res);
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', url);
        link.setAttribute('download', file_name);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.downloading[id].next(false)
        return true
      }, error: (err: any) => {
        this.downloading[id].next(false);
        this.message_broker .next({
          severity: 'error',
          summary: 'Error',
          detail: 'Unable to trim the video. Please try again',
        });
        return false
      }
    })
  }
}
